import {
  SET_FORM_LOADING,
  SET_FROM_DATE,
  SET_TO_DATE,
  SET_VM_OPTIONS,
  SET_VMID,
  SET_SUBMIT_LOADING
} from './constants';

export function setFormLoading(loading) {
  return {
    type: SET_FORM_LOADING,
    loading
  };
}

export function setVMOptionsToStore(vmOptions) {
  return {
    type: SET_VM_OPTIONS,
    vmOptions
  };
}

export function setFromDate(fromDate) {
  return {
    type: SET_FROM_DATE,
    fromDate
  };
}

export function setToDate(toDate) {
  return {
    type: SET_TO_DATE,
    toDate
  };
}

export function setVMId(vmId) {
  return {
    type: SET_VMID,
    vmId
  };
}

export function setSubmitLoading(submitLoading) {
  return {
    type: SET_SUBMIT_LOADING,
    submitLoading
  };
}



// WEBPACK FOOTER //
// ./src/Modules/DownloadCSV/actions.js